import AwsImage from "components/dashboard/AwsImage"
import Hero from "components/Hero"
import Href from "components/Href"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading } from "components/Text"
import { prisma } from "lib/prisma"
import { slugify } from "utils/helpers"

import type { Image as PrismaImage, ProductType } from "@prisma/client"
import type { GetStaticProps, NextPage } from "next"

const Products: NextPage<{
  products: {
    title: string
    images: PrismaImage[]
    id: string
    type: ProductType
    content: string | null
  }[]
}> = ({ products }) => {
  return (
    <>
      <SEO
        pageTitle="Products"
        titleTag={`Products | ${process.env.NEXT_PUBLIC_SITE_NAME}`}
        metaDescription="Products"
      />
      <Layout>
        <Hero heading="Online booking" />
        <Section>
          <Container>
            <div className="grid smmax:grid-cols-1 mdmin:grid-cols-2 gap-6">
              {products.map(product => (
                <Href
                  noUnderline
                  key={product?.id}
                  href={`/products/${slugify(product.title)}`}
                  className="bg-gray-100 hover:scale-105 transition-transform"
                >
                  {product.images?.[0] && (
                    <AwsImage
                      image={product.images[0]}
                      alt={product.title}
                      sizes=""
                      className="w-full object-cover aspect-video"
                    />
                  )}
                  <div className="p-3">
                    <Heading underline={false}>{product.title}</Heading>
                  </div>
                </Href>
              ))}
            </div>
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const products = await prisma.product.findMany({
    where: {
      published: true,
      type: {
        not: "HIDDEN"
      }
    },
    // select the id, title, type, content, and all fields from related images
    select: {
      id: true,
      title: true,
      type: true,
      content: true,
      images: true
    }
  })

  return {
    props: {
      products: JSON.parse(JSON.stringify(products))
    }
  }
}

export default Products
